module.exports = __webpack_public_path__ + "img/booster.514a13a9.png";